// extracted by mini-css-extract-plugin
export default {"base":"SOAPReviewPane_base__hdvHD","visible":"SOAPReviewPane_visible__zxxKy"};